import { Component, OnInit, Inject } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { LocalService } from 'src/app/Services/local.service';
import { QuotationDetails } from 'src/app/Modules/medical/modules/models/quotation-details.model';

@Component({
  selector: 'app-csr-category-dialog',
  templateUrl: './csr-category-dialog.component.html',
  styleUrls: ['./csr-category-dialog.component.css']
})
export class CsrCategoryDialogComponent implements OnInit {

  constructor(public global: GlobalService, public dialogRef: MatDialogRef<CsrCategoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private local:LocalService) { 
      this.local.setObject("allCategory",this.data)
    }

  ngOnInit() {
  }

  selectCategory(data) {
    this.local.setObject("selectedCategory",data)
    this.global.selectedCategory = data;
    this.global.medicalEmitter.emit(data);
    this.global.proposal = new QuotationDetails()
    this.global.quoteDetails.emit(null)
    //this.local.removeObject()
    this.dialogRef.close(data);
  }

}
